import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';
import ScrollToTopButton from './ScrollToTopButton';
import { useRef } from 'react';

const Layout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const mainRef = useRef(null);

  return (
  <div className="flex h-screen bg-secondary-50 dark:bg-secondary-900">
      <Sidebar isOpen={sidebarOpen} setIsOpen={setSidebarOpen} />
      
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header onMenuClick={() => setSidebarOpen(true)} />
        
        <main ref={mainRef} className="flex-1 overflow-auto p-6">
          <Outlet />
        </main>
        <ScrollToTopButton targetRef={mainRef} />
      </div>
    </div>
  );
};

export default Layout;
